var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.49414,10.74365v.00049L9.59082,62.57764A2.83317,2.83317,0,0,0,12.09619,66.75H67.90332a2.83362,2.83362,0,0,0,2.50586-4.17236l-27.90332-51.834a2.84883,2.84883,0,0,0-5.01172,0ZM40,10.75a1.3277,1.3277,0,0,1,1.18555.70508L69.08887,63.28857a1.29711,1.29711,0,0,1-.0293,1.30762,1.33461,1.33461,0,0,1-1.15625.65381H12.09619a1.3344,1.3344,0,0,1-1.15576-.65332,1.298,1.298,0,0,1-.0293-1.30811L38.81445,11.45508A1.3277,1.3277,0,0,1,40,10.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.25781,
    y: 28,
    width: 1.5,
    height: 20.00001
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,58.75A2.75,2.75,0,1,0,37.25,56,2.7528,2.7528,0,0,0,40,58.75Zm0-4A1.25,1.25,0,1,1,38.75,56,1.25116,1.25116,0,0,1,40,54.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/icon_alert.ba8f5808a36d48d799be5e1ea70cfbfa.svg";
export { ForwardRef as ReactComponent };